import _ from "lodash";
import "./verticle-card-component.module.css";
import CommentIcon from "../../../../assets/img/comment.svg";

const VerticalCardComponent = ({ story, showImage, showStrap }) => {
  const featuredImage = _.get(story, "featured_image", "");
  const storyTitle = _.get(story, "title", "");
  const storyStrapLine = _.get(story, "strapline", "");
  const storyAuthor = _.get(story, "authors", []);
  const postMeta = _.get(story, "post_meta", {});
  const categorySlug = _.get(story, ["categories", "slug"], "");
  const categoryName = _.get(story, ["categories", "name"], "");
  const storySlug = _.get(story, "slug", "");

  const isExplainerStory =
    _.get(story, ["post_type", 0, "slug"], "")?.toLowerCase() === "yesterday";
  const url = isExplainerStory
    ? `/yesterday/${storySlug}`
    : `/${categoryName.toLowerCase()}/${storySlug}`;

  const getCategoryColor = (category) => {
    const categoryLowered = _.toLower(category);
    if (categoryLowered === "internet") {
      return "#FC876D";
    } else if (categoryLowered === "business") {
      return "#2CB680";
    } else if (
      categoryLowered === "state of the unicorns" ||
      categoryLowered === "markets"
    ) {
      return "#ecb731";
    } else {
      return "#907CFF";
    }
  };

  return (
    <div className="vertical-card-component-container">
      <a
        href={`/category/${categorySlug}`}
        className="vertical-card-component-title"
        style={{ color: getCategoryColor(categorySlug) }}
      >
        {categoryName}
      </a>
      {showImage && (
        <a href={url} className="vertical-card-component-image-container">
          <img
            src={featuredImage}
            alt="image"
            className="vertical-card-component-image"
          />
        </a>
      )}
      <div className="vertical-card-component-content">
        <a
          href={url}
          className="vertical-card-component-content-title"
          style={{
            fontSize: showStrap ? "24px" : "16px",
            marginTop: !showStrap ? "0px" : "10px",
            marginBottom: !showStrap ? "0px" : "10px",
            lineHeight: !showStrap ? "24px" : "32px",
            cursor: "pointer",
          }}
        >
          {storyTitle}
        </a>
        {showStrap && (
          <a
            href={url}
            className="vertical-card-component-content-strapline"
            style={{ cursor: "pointer" }}
          >
            {storyStrapLine}
          </a>
        )}

        <div className="vertical-card-component-line"></div>
        <div className="vertical-card-component-content-author-container">
          <a
            href={`/writers/${storyAuthor[0]?.slug}`}
            className="vertical-card-component-content-author"
          >
            <a
              href={`/writers/${storyAuthor[0]?.slug}`}
              className="vertical-card-component-content-author-image-container"
            >
              <img src={storyAuthor[0]?.profile_picture} alt="author" />
            </a>

            <a
              href={`/writers/${storyAuthor[0]?.slug}`}
              className="vertical-card-component-content-author-name"
            >
              {storyAuthor[0]?.full_name}
            </a>
          </a>

          <a
            href={`${url}?showComment=true`}
            className="vertical-card-component-content-comment-icon"
          >
            <img src={CommentIcon} alt="comment" />
            <p className="vertical-card-component-content-comment-count">
              {postMeta?.comment_count}
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default VerticalCardComponent;
